<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">ชื่อ - นามสกุล (Name & Surname)</th>
              <th class="text-center">ที่อยู่/ที่ทำงาน Address/Office</th>
              <th class="text-center">โทรศัพท์ Telephone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in 2" :key="i">
              <td>
                <v-text-field
                  v-model="$store.state.dataFrm.list_Emer.tea_emer_name[i]"
                  :label="'ชื่อ - สกุล (Name & Surname)  คนที่ ' + (i + 1)"
                ></v-text-field>
              </td>

              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_Emer.tea_emer_address[i]"
                  :label="'ที่อยู่ คนที่ ' + (i + 1)"
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-text-field
                  v-model="$store.state.dataFrm.list_Emer.tea_emer_phone[i]"
                  :label="'เบอร์โทรศัพท์ คนที่ ' + (i + 1)"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <!-- {{$store.state.dataFrm.list_Emer}} -->
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {};
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
